import React from 'react';

// This is Grove's public, signed-out home page (grove.mcschaef.family/).
// It has to explain what the app is and stay reachable without signing in —
// Google's OAuth consent screen branding verification checks both.
export default function SignInScreen({ onSignIn }) {
  return (
    <div className="landing-screen">
      <div className="landing-screen__hero">
        <div className="landing-screen__kicker-wrap">
          <span className="landing-screen__kicker">Welcome to</span>
          <h1>Grove — Family Ops Hub</h1>
        </div>

        <div className="signin-card">
          <img src="/grove-logo.png" alt="Grove" className="signin-card__logo" />
          <p className="signin-card__sub">Calm, organised, together.</p>
          <button className="btn btn--google" onClick={onSignIn}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
              <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853"/>
              <path d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
              <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
            </svg>
            Sign in with Google
          </button>
          <p className="signin-card__note">Family access only</p>
        </div>

        <div className="landing-screen__pitch">
          <p>
            Grove — Family Ops Hub is a private family logistics app. It
            brings a household's calendars, caregivers, and day-to-day
            details into one calm place, so the people who help run a
            family — parents, grandparents, and babysitters — can all see
            what's happening without a chain of texts.
          </p>
          <p>
            Once a household signs in with Google, Grove reads the family's
            connected Google Calendars to build a shared schedule view,
            showing who is covering pickup, drop-off, and care each day.
            Owners can then invite caregivers with scoped access — sharing
            only the schedule, kid info, house info, or emergency contacts
            each person actually needs — either by email or a private link.
          </p>
          <p>
            Grove is independently operated, is not affiliated with Google,
            and does not sell data or run advertising. See{' '}
            <a href="/about">About</a>,{' '}
            <a href="/privacy">Privacy Policy</a>, and{' '}
            <a href="/terms">Terms of Service</a> for details.
          </p>
        </div>
      </div>

      <div className="landing-screen__footer">
        <a href="/about">About</a>
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms</a>
      </div>
    </div>
  );
}
